import { Spinner } from "react-bootstrap";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import { displayNotification, generateOptionsFromData } from "helpers";
import { useGetListByMasterKeyQuery, useLazyGetListByMasterKeyQuery } from "modules/pvs_activities/redux/service/lists";
import { useCreateMissionDocumentsMutation } from "modules/pvs_activities/redux/service/missions";
import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import FileField from "../core/FileField";
import { Mission_Document_type } from "modules/pvs_activities/constants";


const UploadDocumentModel = ({ isShow, uploadModel, typeName, showCategoriesFilters, missionID, documentTypeID, documentCatagory, documentSubCatagory, userID }) => {
  const [createMissionDocuments, { isLoading }] = useCreateMissionDocumentsMutation();
  const [form, setForm] = useState({
    type_id: documentTypeID,
    category_id: documentCatagory ?? "",
    subcategory_id: documentSubCatagory ?? "",
    mission_id: missionID,
    user_id: userID,
  });
  const [file, setFile] = useState([]);

  const categoryListRes = useGetListByMasterKeyQuery(
    {
      key: "MDOCCT",
      params: {
        order_by: "list_element_name,asc",
        parent_id: documentTypeID ?? "0",

      },
    },
    { skip: documentTypeID === "" }
  );
  const [subcategoryTrigger, subcategoryListRes] = useLazyGetListByMasterKeyQuery();

  useEffect(() => {
    const categoryId = form.category_id;
    const typeId = documentTypeID;
    if (categoryId !== '') {
      const isBaseline = parseInt(typeId) === Mission_Document_type.baseline_document;
      subcategoryTrigger({
        key: "MDOCSC",
        params: {
          parent_id: isBaseline ? typeId : categoryId ?? "0",
          order_by: "list_element_name,asc",
        },
      });
    }
  }, [form.category_id, form.type_id]);

  const categoriesOptions = useMemo(() => {
    return generateOptionsFromData(categoryListRes.data ?? [], {
      value: "id",
      label: "list_element_name",
    });
  }, [categoryListRes.data]);

  const subCategoriesOptions = useMemo(() => {
    return generateOptionsFromData(subcategoryListRes.data ?? [], {
      value: "id",
      label: "list_element_name",
    });
  }, [subcategoryListRes.data]);

  const handlePopupValueChange = (name, value) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const requiredFields = [
      { key: "type_id", label: "Type" },
      { key: "category_id", label: "Category" },
      { key: "subcategory_id", label: "Subcategory" },
      { key: "mission_id", label: "Mission" },
      { key: "user_id", label: "User" },
    ];

    for (const field of requiredFields) {
      if (!form[field.key]) {
        displayNotification("warning", `${field.label} is required`);
        return;
      }
    }

    if (!file?.length) {
      displayNotification("warning", " file is required");
      return;
    }

    const formData = new FormData();
    requiredFields.forEach(field => formData.append(field.key, form[field.key]));
    file.forEach(fileItem => formData.append("file_name", fileItem));

    const response = await createMissionDocuments(formData);
    if (response.error) {
      displayNotification("error", "An error occurred when submitting");
    } else {
      displayNotification("success", "Successfully Submitted Document");
      setFile([]);
      uploadModel();
    }
  };


  return (
    <>
      <Modal show={isShow}>
        <Modal.Header closeButton onClick={() => uploadModel()}>
          <Modal.Title>Upload Document - {typeName}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {
            showCategoriesFilters &&
            <>
              {/* <AutoCompleteDropdown
                // disabled={true}
                showClearIcon={false}
                error={false}
                required={false}
                multiple={false}
                label={"Type"}
                hasselectall={false}
                name="type_id"
                options={typesOptions}
                onChange={(event, value) => handlePopupValueChange("type_id", value.value)}
                value={typesOptions.find((r) => r.value === form.type_id) ?? null}
              /> */}
              <AutoCompleteDropdown
                showClearIcon={false}
                error={false}
                required={false}
                multiple={false}
                label={"Category"}
                hasselectall={false}
                options={categoriesOptions}
                onChange={(event, value) => handlePopupValueChange("category_id", value.value)}
                value={categoriesOptions.find((r) => r.value === form.category_id) ?? null}
              // disabled={documentCatagory ? true : false}
              />
              <AutoCompleteDropdown
                showClearIcon={false}
                error={false}
                required={false}
                multiple={false}
                label={"Subcategory"}
                hasselectall={false}
                options={subCategoriesOptions}
                onChange={(event, value) => handlePopupValueChange("subcategory_id", value.value)}
                value={subCategoriesOptions.find((r) => r.value === form.subcategory_id) ?? null}
              // disabled={documentSubCatagory ? true : false}
              />
            </>
          }
          <FileField
            textfieldProps={{ label: "File" }}
            autoCompleteProps={{ className: "my-2" }}
            width={"98%"}
            files={file}
            setFiles={setFile}
          />
        </Modal.Body>

        <Modal.Footer>
          <div className="col-md-12 d-flex justify-content-center">
            <Button variant="primary" onClick={handleSave}>
              {isLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-3" /> <span>Uploading</span>
                </>
              ) : (
                <span>Upload</span>
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
UploadDocumentModel.defaultProps = {
  isShow: false,
  typeName: 'Baseline',
  showCategoriesFilters: false,
  uploadModel: () => { },
};
export default UploadDocumentModel;
